import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import StackedLineChartIcon from '@mui/icons-material/StackedLineChart';
import PaymentIcon from '@mui/icons-material/Payment';
import AssessmentIcon from '@mui/icons-material/Assessment';
import StorageIcon from '@mui/icons-material/Storage';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import {useNavigate} from "react-router-dom";
import {urls} from "../../../business/routes/urls";

export const LeftMenuSection = ({toggleDrawerLeftMenu,open}) => {

    const navigate = useNavigate();

    return (
        <div>
            <Drawer open={open} onClose={toggleDrawerLeftMenu(false)} >
                 <Box sx={{ width: 300 }} role="presentation" onClick={toggleDrawerLeftMenu(false)}>
                    <List>
                        <ListItem key={'Proposal'} disablePadding>
                            <ListItemButton onClick={() =>  navigate(urls.statistics)}>
                                <ListItemIcon>
                                    <StackedLineChartIcon />
                                </ListItemIcon>
                                <ListItemText primary={'Proposal'} />
                            </ListItemButton>
                        </ListItem>
                        <ListItem key={'KPI'} disablePadding>
                            <ListItemButton onClick={() =>  navigate(urls.kpi)}>
                                <ListItemIcon>
                                    <AssessmentIcon />
                                </ListItemIcon>
                                <ListItemText primary={'KPI'} />
                            </ListItemButton>
                        </ListItem>
                        <ListItem key={'Payments'} disablePadding>
                            <ListItemButton onClick={() =>  navigate(urls.payments)}>
                                <ListItemIcon>
                                    <PaymentIcon />
                                </ListItemIcon>
                                <ListItemText primary={'Payments'} />
                            </ListItemButton>
                        </ListItem>
                        <ListItem key={'Storage Income'} disablePadding>
                            <ListItemButton onClick={() =>  navigate(urls.storageExpectedIncome)}>
                                <ListItemIcon>
                                    <StorageIcon />
                                </ListItemIcon>
                                <ListItemText primary={'Storage Income'} />
                            </ListItemButton>
                        </ListItem>
                        <ListItem key={'MC Ops Dashboard'} disablePadding>
                            <ListItemButton onClick={() =>  navigate(urls.mcOpsDashboard)}>
                                <ListItemIcon>
                                    <HeadsetMicIcon />
                                </ListItemIcon>
                                <ListItemText primary={'MC Ops Dashboard'} />
                            </ListItemButton>
                        </ListItem>
                    </List>
                </Box>
            </Drawer>
        </div>
    );
}